"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariationType = exports.Level = exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["BREAKPOINT"] = "breakpoint";
    TokenType["CHARACTER"] = "character";
    TokenType["COLOR"] = "color";
    TokenType["CORNER_RADIUS"] = "corner-radius";
    TokenType["CUSTOM_FONT"] = "custom-font";
    TokenType["DURATION"] = "duration";
    TokenType["ENABLED"] = "enabled";
    TokenType["ELEVATION"] = "elevation";
    TokenType["FONT_FAMILY_STACK"] = "font-family-stack";
    TokenType["FONT_NAME"] = "font-name";
    TokenType["FONT_UNICODE_RANGE"] = "font-unicode-range";
    TokenType["GRADIENT"] = "gradient";
    TokenType["ICON"] = "icon";
    TokenType["ILLUSTRATION"] = "illustration";
    TokenType["LENGTH"] = "length";
    TokenType["MARK"] = "mark";
    TokenType["MISSING"] = "missing";
    TokenType["MOTION_EASING"] = "motion-easing";
    TokenType["OPACITY"] = "opacity";
    TokenType["PLACEHOLDER"] = "placeholder";
    TokenType["SHADOW"] = "shadow";
    TokenType["SIZING"] = "sizing";
    TokenType["SPACING"] = "spacing";
    TokenType["TEXT_SHADOW"] = "text-shadow";
    TokenType["TYPE"] = "type";
    TokenType["TYPE_FACE"] = "type-face";
    TokenType["TYPE_SIZE"] = "type-size";
    TokenType["TYPE_LEADING"] = "type-leading";
    TokenType["TYPE_WEIGHT"] = "type-weight";
    TokenType["TYPE_DECORATION"] = "type-decoration";
    TokenType["URL"] = "url";
    TokenType["MISSING_URL"] = "missing-url";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var Level;
(function (Level) {
    Level["FOUNDATION"] = "foundation";
    Level["SEMANTIC"] = "semantic";
    Level["FEATURE"] = "feature";
    Level["THEME"] = "theme";
})(Level = exports.Level || (exports.Level = {}));
var VariationType;
(function (VariationType) {
    VariationType["DARK"] = "dark";
    VariationType["RTL"] = "rtl";
})(VariationType = exports.VariationType || (exports.VariationType = {}));
//# sourceMappingURL=token.js.map